var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_MessageType_list_dialog_viewTypeTitle"),
      dialog: _vm.show,
      width: "700",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            bindData: _vm.Data.message_type_name,
                            label: _vm.$t(
                              "label_essweb_MessageType_list_dialog_messageTypeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.message_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            maxlength: "100",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_codeLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.message_type_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "message_type_code", $$v)
                            },
                            expression: "Data.message_type_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_MessageType_list_dialog_messageTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.messageType,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_MessageType_list_dialog_messageTypeLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.message_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "message_type", $$v)
                            },
                            expression: "Data.message_type",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text-subtitle-2" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_MessageType_list_dialog_formEmailGroupTitleLabel"
                                )
                              ) +
                              ": "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_MessageType_list_dialog_emailTemplateLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-select", {
                          attrs: {
                            items: _vm.emailTemplate,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_MessageType_list_dialog_emailTemplateLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.mail_mode_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "mail_mode_uuid", $$v)
                            },
                            expression: "Data.mail_mode_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-checkbox", {
                          staticClass: "mt-0",
                          attrs: {
                            disabled: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_MessageType_list_dialog_isSendEmailLabel"
                            ),
                            "hide-details": "",
                            required: "",
                          },
                          model: {
                            value: _vm.Data.is_mail_send,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "is_mail_send", $$v)
                            },
                            expression: "Data.is_mail_send",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text-subtitle-2" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_MessageType_list_dialog_formPushGroupTitleLabel"
                                )
                              ) +
                              ": "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_MessageType_list_dialog_sendEmailTemplateLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-select", {
                          attrs: {
                            items: _vm.notiTemplate,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_MessageType_list_dialog_sendEmailTemplateLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.message_mode_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "message_mode_uuid", $$v)
                            },
                            expression: "Data.message_mode_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_MessageType_list_dialog_sendPlatformLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.platform,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_MessageType_list_dialog_sendPlatformLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.message_platform,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "message_platform", $$v)
                            },
                            expression: "Data.message_platform",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-checkbox", {
                          staticClass: "mt-0",
                          attrs: {
                            disabled: !_vm.iSEdited,
                            "hide-details": "",
                            label: _vm.$t(
                              "label_essweb_MessageType_list_dialog_isSendNotificationLabel"
                            ),
                            required: "",
                          },
                          model: {
                            value: _vm.Data.is_message_send,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "is_message_send", $$v)
                            },
                            expression: "Data.is_message_send",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { save: _vm.toSave, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }